import { Quote as QuoteSVG } from 'lucide-react';
import { FC } from 'react';

import { Container, Text, Title, TitleContainer } from './Quote.styled';

export type QuoteProps = {
  title: string;
  quote: string;
};

export const Quote: FC<QuoteProps> = ({ title, quote }) => (
  <Container data-testid="quote">
    <TitleContainer>
      <QuoteSVG fill="#C18244" stroke="#C18244" size={24} />
      <Title>{title}</Title>
    </TitleContainer>
    <Text>”{quote}”</Text>
  </Container>
);
